<template>
  <div class="inner-container">
      <div class="content-container4">
        <div class="progress-container4 mb-8">
          <div class="progress-bar4"></div>
        </div>


        <!-- Hier wird die Klasse aktualisiert -->
        <div>
          <div class="display-1 mb-8 text-center">
            Welche Box möchten Sie haben?
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <v-icon class="ml-2" v-bind="attrs" v-on="on" @click="openModal">mdi-information-outline</v-icon>
              </template>
              <span>Details anzeigen</span>
            </v-tooltip>
          </div>
          <v-row class="align-center justify-center">
            <v-col v-for="box in preDesignedBoxes" :key="box.title" cols="12" md="4">
              <v-card
                  :color="selectedBox && selectedBox.title === box.title ? 'primary' : 'white'"
                  @click="handleBoxClick(box)"
                  class="hoverable-card mb-4"
              >
                <v-img :src="box.image"
                       contain
                       height="300px"
                       width="360px"
                ></v-img>

                <div class="label-container text-center white--text display-1">
                  {{ box.title }}
                </div>
              </v-card>
            </v-col>
          </v-row>
        </div>





        <router-link
            to="/boxauswahl"
            class="text-center d-block mt-10 custom-link"
            color="primary"
            style="font-weight: bold; font-size: 40px;"
        >
          Box individuell Zusammenstellen
        </router-link>

        <v-dialog v-model="showModal" max-width="600px">
          <v-card>
            <v-card-title>
              <span class="headline">Details zu den Boxen</span>
            </v-card-title>
            <v-card-text>
              <p class="modal-intro">
                Entdecken Sie unsere sorgfältig zusammengestellten Boxen. Jede Box wurde mit Bedacht entworfen, um unterschiedlichen Bedürfnissen gerecht zu werden. Ein Blick auf die folgende Liste zeigt Ihnen den Inhalt jeder Box. Falls Sie spezielle Vorlieben oder Bedürfnisse haben, bieten wir Ihnen auch die Möglichkeit, Ihre eigene, individuelle Pflegebox zusammenzustellen. Die Wahl liegt bei Ihnen!
              </p>
              <div v-for="(box, index) in preDesignedBoxes" :key="box.title" :class="{ 'increased-margin': index > 0 }">
                <strong>{{ box.title }}</strong>
                <ul>
                  <li v-for="productId in box.productIds" :key="productId">{{ productIdToTitle(productId) }}</li>
                </ul>
              </div>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green darken-1" text @click="showModal = false">Schließen</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>




      </div>
  </div>
</template>



<script>
import { mapActions, mapGetters, mapState } from 'vuex';
import PBStepper from "@/components/PB-Stepper.vue";


export default {
  components: { PBStepper },
  data: () => ({
    selectedBox: null,
    showModal: false,
    productMapping: {
      'EH': 'Einmalhandschuhe - 100 Stück',
      'F': 'FFP 2 Maske - 1 Stück',
      'M50': 'Mundschutz - 50 Stück',
      'HD': 'Händedesinfektionsmittel - 500ml',
      'FD': 'Flächendesinfektionsmittel - 500ml',
      'ES': 'Schutzschürzen - 100 Stück',
      'B': 'Bettschutz - 25 Stück',
      'WB': 'Wiederverwendbarer Bettschutz - 1 Stück',
      'W': 'Waschlappen - 100 Stück',
      'FI': 'Fingerlinge - 100 Stück',
      // ... andere Produkt-IDs und ihre Titel
    }
}),
  computed: {
    ...mapGetters([
      'totalValue',
    ]),
    ...mapState({
      'preDesignedBoxes': state => state.system.preDesignedBoxes
    }),
  },
  methods: {
    ...mapActions([
      'selectBoxMethod',
      'goToNextStep'
    ]),
    productIdToTitle(id) {
      return this.productMapping[id] || 'Unbekanntes Produkt'; // Gibt 'Unbekanntes Produkt' zurück, wenn die ID nicht gefunden wird
    },
    openModal() {
      this.showModal = true;
    },
    selectBoxMethod(box) {
      this.$store.commit('selectBox', box.id);
    },
    handleBoxClick(box) {
      this.selectBoxMethod(box);  // Speichern Sie die ausgewählte Box im Store
      this.navigateToBox();    // Navigieren Sie zur entsprechenden Route
    },
    navigateToBox() {
      this.$router.push('/bettschutz');
      this.$vuetify.goTo(0).then()
    },
  }
};
</script>

<style>

.increased-margin {
  margin-top: 20px;  /* Sie können den Wert nach Bedarf anpassen */
}

.modal-intro {
  font-size: 1.3em;  /* Je nach Vorliebe anpassen */
  margin-bottom: 20px;  /* Abstand zwischen Einleitung und Box-Details */
}

.inner-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.content-container4 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;  /* Dies verteilt den Raum zwischen den Hauptblöcken */
  min-height: 80vh;
  padding: 0 15px;
}

.progress-container4 {
  display: flex;  /* Hinzugefügt, um Flex-Container zu aktivieren */
  width: 40%;
  height: 20px;
  align-items: center;  /* Dies wird den Fortschrittsbalken vertikal zentrieren */
  background-color: #f0f0f0; /* Hintergrundfarbe des Fortschrittsbalkens */
}

.progress-bar4 {
  width: 80%; /* 2 von 5 Schritten -> 40% */
  height: 100%;
  background-color: var(--v-primary-base); /* Primärfarbe des Fortschrittsbalkens */
}

.label-container {
  background-image: linear-gradient(315deg, #17aa9b, #17aa9b 80%);
  padding: 10px 0;
  font-size: 1.5em;
  width: 100%;
}



/* Hervorhebungsstil für die Karte beim Darüberfahren */
.hoverable-card {
  transition: transform 0.2s;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.hoverable-card:hover {
  transform: scale(1.05);  /* Karte vergrößern */
}

.custom-link {
  text-decoration: none;
  font-size: 18px;  /* Sie können die Größe nach Bedarf anpassen */
  transition: color 0.3s ease;  /* Für eine sanfte Farbänderung beim Überfahren */
  margin-top: 0px;
}

.custom-link:hover {
  color: #f98918;  /* Eine Farbe beim Überfahren. Sie können dies an Ihre Vorlieben anpassen */
}

/* Für Mobilgeräte */
@media (max-width: 900px) {
  .content-container4 {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;  /* Dies verteilt den Raum zwischen den Hauptblöcken */
    min-height: 80vh;
    padding: 15px 15px;
  }
}
</style>
